export default __webpack_public_path__ + "static/media/background2.bf2c9b71.svg";